import styled from 'styled-components';
import { topbarHeight } from '../../../components/_shell/Navbar';
import { contentSelectionHeight } from '../../../components/_shell/TabContentSelection';

export const PageContent = styled.main`
  /* padding-top: 2rem; */

  width: 100%;
  display: grid;
  grid-template-columns: 2fr 420px;
  grid-template-rows: 65vh 1fr;
  margin-top: 150px;
  margin: ${`${topbarHeight + contentSelectionHeight + 100}px auto 0 auto`};

  @media (max-width: 1241px) {
    grid-template-columns: 1fr;
  }

  aside {
    .author i {
      margin-right: 5px;
    }

    .related-informatives-list {
      border-bottom: 1px solid #ccc;
      margin-bottom: 15px;
      padding-bottom: 15px;

      .thumb {
        position: relative;
        display: block;

        img {
          width: 100%;
        }

        a {
          display: block;
        }
      }

      .thumb-cover {
        > div.author {
          background: #00336c;
          background: rgb(0 51 108 / 75%);
          color: #fff;
          position: absolute;
          bottom: 5px;
          left: 5px;
          display: inline-block;
          border-radius: 4px;
          padding: 2px 5px;
        }
      }

      > div.author {
        display: none;
      }

      h4 {
        font-size: 16px;
        line-height: 1.4;
        font-weight: 500;
        margin-top: 5px;

        a {
          color: #00336c;

          &:hover,
          &:focus,
          &:active {
            color: #00336c;
          }
        }
      }
    }
  }

  @media (max-width: 1239px) {
    aside {
      .related-informatives {
        display: grid;
        overflow: hidden;
        grid-template-columns: repeat(3, 1fr);
        grid-auto-rows: max-content;
        grid-column-gap: 5px;
        grid-row-gap: 5px;
      }

      .related-informatives-list {
        .thumb-cover {
          aspect-ratio: 16 / 9;
          width: 100%;
          height: 154px;
          overflow: hidden;
          position: relative;

          img {
            object-fit: cover;
            margin-top: -15px;
          }

          > div.author {
            display: none;
          }
        }

        > div.author {
          display: block;
        }
      }
    }
  }

  @media (max-width: 900px) {
    aside {
      .related-informatives {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }

  @media (max-width: 650px) {
    aside {
      .related-informatives {
        grid-template-columns: repeat(1, 1fr);
      }

      .related-informatives-list {
        .thumb-cover {
          height: 275px;
        }
      }
    }
  }

  .informatives-container {
    grid-column: 1/2;
    grid-row: 1;
    background: #323232;
    max-width: 1100px;
    margin-left: 34px;

    @media (max-width: 1241px) {
      grid-column: 1;
    }
  }

  .playlist-container {
    padding: 0 0.8rem;
    grid-column: 2/3;
    grid-row: 1 / 3;
    background: #fff;

    @media (max-width: 1241px) {
      grid-column: 1;
      grid-row: 3 / 3;
    }
  }

  .informatives-details-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    grid-column: 1/ 2;
    grid-row: 2 / 3;
    background: #fff;
    padding: 1.5rem 2rem 6rem 2rem;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    height: 100%;

    .container {
      max-width: 940px;

      .details {
        margin-bottom: 1.5rem;
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: 0.5rem;
        grid-column-gap: 0.5rem;
        .palavras-chave {
        }
      }
    }
    @media (max-width: 1241px) {
      grid-column: 1;
      padding: 1.5rem 2rem;
    }

    @media (max-width: 600px) {
      padding: 1rem;
    }

    h3 {
      font-size: 1.5rem;
    }

    ul {
      list-style: none;
      margin-bottom: 1.5rem;
    }
  }
`;

export const InformativesContainer = styled.div`
  .vjs-big-play-button {
    width: 70px !important;
    height: 60px !important;
  }

  .vjs-selected {
    background: #8a8a8a !important;
  }
`;

export const InformativesNavBarContainer = styled.div`
  .filter-btn,
  .filter-btn-alter {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35.2px;
    font-size: 14px;
    font-weight: 400;
    margin-right: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: transparent;
    cursor: pointer;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 16px;
    padding-right: 16px;
    color: #323232;
    transition: background-color 0.1s ease-in-out, font-size 0.1s ease-in-out;

    &:hover {
      background-color: #004c92;
      border: 1px solid #ccc;
      color: #fff;
    }

    &:focus {
      border-color: #fff;
    }

    .ant-badge {
      position: absolute;
      top: -11px;
      right: -11px;

      p {
        color: #fff;
        font-size: 12px;
        font-weight: 700;
      }
    }

    .anticon-down {
      font-size: 10px;
      margin-left: 12px;
      margin-top: 2px;
    }
  }

  .filter-btn-alter {
    background-color: #004c92;
    color: #fff;
    border-color: #004c92;

    &:hover,
    &:focus,
    &:active {
      background-color: #004c92;
      border-color: #004c92;
    }
  }
`;

export const InformativesNavBarResults = styled.div`
  .filter-search {
    width: 300px;
    display: block;
  }

  .results {
    margin-top: 15px;
    width: 300px;
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .error,
  .empty {
    width: 300px;
    text-align: center;
    border-radius: 4px;
    margin-top: 10px;
    font-size: 12px;
    line-height: 2;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }

  .error {
    background: #ffcaca;
  }

  .empty {
    background: #feffca;
  }

  .anticon-loading {
    margin: 10px auto 0 auto;
    display: block;
  }

  .ant-checkbox-wrapper {
    width: 100%;
    display: flex;
    justify-items: center;
    align-items: center;
    margin: 0;
    user-select: none;
    padding: 2px 5px;

    &:nth-child(odd) {
      background: #f6f6f6;
    }

    &:hover {
      background: #f1f1f1;
    }

    + .ant-checkbox-wrapper {
      margin: 0;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background: #003a70;
      border-color: #003a70;
    }
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #003a70;
  }

  .selecteds {
    width: 300px;
    display: block;
    margin-bottom: 10px;
    user-select: none;

    .ant-tag {
      overflow: hidden;
      position: relative;
      padding: 0 25px 0 5px;
      max-width: 300px;

      .anticon-close {
        background: #003a70;
        color: #fff;
        padding: 7px;
        margin: -2px -3px -3px 0;
        border-radius: 0 3px 3px 0;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;

        &:hover,
        &:focus,
        &:active {
          background: #01498d;
          color: #fff;
        }
      }
    }
  }
`;

export const InformativesNavBarAdvanced = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  width: 622px;

  span {
    white-space: pre;
    margin-right: 15px;
  }

  input[type='text'] {
    width: 300px;
  }

  .pointer {
    cursor: pointer;
    user-select: none;
  }

  .label {
    padding-top: 8px;
    font-weight: 500;
  }

  .mt-5 {
    margin-top: 10px;
  }

  .ant-checkbox-wrapper {
    width: 112px;
    margin-left: 10px;

    .ant-checkbox {
      margin: 0;

      input,
      + span,
      .ant-checkbox-inner {
        margin: 0;
      }
    }
  }
`;

export const InformativesNavBarClear = styled.div`
  .ant-btn-danger {
    background: none transparent;
    border: 2px solid #d7282f;
    color: #d7282f;
    min-width: min-content;
    width: auto;
    outline: none;
    border-radius: 12px;
    font-weight: 500;
    padding: 11px 20px;
    margin: 0 10px 0 0;
    height: auto;
    line-height: 1;
    font-size: 14px;
    position: relative;

    &:hover,
    &:focus,
    &:active {
      border: 2px solid #d7282f;
      color: #d7282f;
    }

    .ant-badge {
      position: absolute;
      top: -11px;
      right: -11px;

      p {
        color: #fff;
        font-size: 12px;
        font-weight: 700;
      }
    }
  }
`;

export const InformativesNavBarDates = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 300px;

  .ant-select {
    width: 110px;
  }

  > span {
    margin: 0 10px;

    &:first-child {
      margin-left: 0;
    }
  }
`;

export const Image = styled.img`
  border-radius: 12px;
  max-width: 180px;
`;

export const ImageAI = styled.img`
  border-radius: 12px;
  max-width: 110px;
`;

export const InformativesOrder = styled.div`
  .ant-select {
    width: 200px;
  }
  .ant-select-selection {
    border-radius: 10px !important;
  }
`;

export const SubFilters = styled.div`
  margin: 60px 0 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: stretch;
  justify-content: flex-end;
  align-items: baseline;

  > p {
    margin: 0 15px 0 0;
  }

  .b {
    color: #003a70;
    font-weight: 600;
  }

  .r {
    color: #d7282f;
    font-weight: 600;
  }
`;

export const InformativesInnerFields = styled.div`
  margin: 0;

  &:not(:last-child) {
    margin: 0;
  }

  span {
    margin-left: 5px;
    color: #003a70;
    font-size: 14px;
  }

  img {
    width: 22px;
    height: 18px;
  }
`;

export const InformativesResultEmpty = styled.p`
  margin-top: 2em;
  font-size: 1.4em;
`;

export const InformativesInfoPopover = styled.div`
  position: absolute;
  z-index: 1;
  padding: 8px;
  background-color: #fff;
  border: 1px solid #ddd;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 8px;
`;

export const InformativesInfo = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 4px;

  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    ${InformativesInfoPopover} {
      display: block;
    }
  }
`;

export const InformativeCoverContainer = styled.div`
  width: 180px;
  height: 260px;
  text-align: center;
  background-size: 180px 260px;
  background-repeat: no-repeat;
  display: flex;
  border-radius: 12px;
`;

export const InformativeCoverContainerAI = styled.div`
  width: 110px;
  height: 146px;
  text-align: center;
  background-size: 110px 146px;
  background-repeat: no-repeat;
  display: flex;
  border-radius: 12px;
`;

export const InformativeCover = styled.span`
  font-family: 'Arial, Helvetica, sans-serif';
  color: #fff;
  display: table-cell;
  align-self: flex-end;
  font-size: 10px;
  margin-bottom: 21px;
  margin-left: 10px;
`;
